import {
  FaReact,

  FaGitAlt,
  FaGithub,
  FaNpm,
  FaFigma,

} from "react-icons/fa";
import { DiNodejs, DiJavascript1 } from "react-icons/di";
import {
  SiExpress,
  SiMongodb,
  SiNextdotjs,
  SiNestjs,
  SiPostgresql,
  SiTailwindcss,
  SiHtml5,
  SiCss3,
  SiTypescript,
  SiSass,
  SiPython,
  SiGraphql,
  SiVitest,
  SiMysql,
  SiBootstrap,
} from "react-icons/si";

const Skills = ({ skill }) => {
  const icon = {
    HTML: <SiHtml5 />,
    CSS: <SiCss3 />,
    Typescript: <SiTypescript />,
    React: <FaReact />,
    Node: <DiNodejs />,
    Javascript: <DiJavascript1 />,
    Express: <SiExpress />,
    MongoDb: <SiMongodb />,
    Git: <FaGitAlt />,
    Github: <FaGithub />,
    Npm: <FaNpm />,
    Figma: <FaFigma />,
    Next: <SiNextdotjs />,
    Nest: <SiNestjs />,
    Postgre: <SiPostgresql />,
    Tailwind: <SiTailwindcss />,
    Sass: <SiSass />,
    Python: <SiPython />,
    GraphQL: <SiGraphql />,
    Vitest: <SiVitest />,
    MySQL: <SiMysql />,
    Bootstrap: <SiBootstrap />,
  };

  return (
    <div title={skill} className="SkillBox">
      {icon[skill]}
    </div>
  );
};

export default Skills;
